'use client';

import { useState } from 'react';
import { useCart } from '@/components/CartProvider';

export default function AddToCartButton({ product }) {
    const { addToCart } = useCart();
    const [isAdded, setIsAdded] = useState(false);

    const handleAdd = () => {
        addToCart(product);
        setIsAdded(true);
        setTimeout(() => setIsAdded(false), 2000); // Reset after 2s
    };

    return (
        <button
            onClick={handleAdd}
            className={`btn ${isAdded ? 'btn-secondary' : 'btn-primary'}`}
            style={{ width: '100%', padding: '1rem', fontSize: '1.125rem' }}
        >
            {isAdded ? '已加入購物車 ✓' : '加入購物車'}
        </button>
    );
}
